<template>
  <main class="main-container">
    <header class="header">
      <strong>
        {{ $gettext("REGISTRATION") }}:
        {{ consumerUnit.toString().padStart(6, "0") }} |
        {{state.serviceRequests[protocol].consumerUnits[consumerUnit].infoCad.consumerUnitType.value}}
      </strong>
    </header>
    <div class="content-grid">
      <aside class="sidebar">
        <div class="card info-card">
           <service-request-consumer-unit-card
            :protocol="protocol"
            :consumerUnit="consumerUnit"
          />
        </div>
        <div class="menu">
          <div class="menu-scroll">
            <service-request-consumer-unit-menu
              :protocol="protocol"
              :consumerUnit="consumerUnit"
            />
          </div>
          <div class="menu-footer">
          <q-btn
              class="btn-close-call full-width button"
              @click="controller.finishBegin({ protocol: protocol })"
            >
              <q-icon name="mdi-close-circle" class="icon-close q-mr-xs" />
              {{ $gettext("CALL_CLOSE") }}
            </q-btn>
          </div>
        </div>
      </aside>
      <section class="main-content">
        <div class="table-container">
          <router-view />
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import ServiceRequestModel from '../ServiceRequestModel'
import ServiceRequestController from '../ServiceRequestController'
import ServiceRequestConsumerUnitCard from './ServiceRequestConsumerUnitCard.vue'
import ServiceRequestConsumerUnitMenu from './ServiceRequestConsumerUnitMenu.vue'

@Observer
@Component({
  name: 'ServiceRequestConsumerUnit',
  components: {
    ServiceRequestConsumerUnitMenu,
    ServiceRequestConsumerUnitCard
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestConsumerUnit extends Vue {
  state = ServiceRequestModel.getInstance();
  controller = ServiceRequestController.getInstance();
  get stade () {
    return this.state
  }

  mounted () {
    const serviceRequest = this.state.serviceRequests[this.protocol]
    const consumerUnit = serviceRequest.consumerUnits[this.consumerUnit]

    if (!consumerUnit.router) {
      const menu = consumerUnit.menu
      const activeGroup = Object.values(menu).find((item) => item.active)
      const activeItem = activeGroup?.list.find((i) => i.active)

      if (activeItem) {
        consumerUnit.router = {
          name: activeItem.nmContainerJavaScript,
          params: {
            consumerUnit: this.consumerUnit,
            protocol: this.protocol
          }
        }
      }
    }

    const router = consumerUnit.router
    if (router) {
      this.controller.router(router)
    }
  }
}
export default ServiceRequestConsumerUnit
</script>
<style lang="stylus" scoped>
@import '~quasar-variables'
.main-container
  display: flex
  flex-direction: column
  height: 100%
  background-color: #f5f5f5

.header
  display: flex
  align-items: center
  padding: 0.5rem 1rem
  min-height: 3rem
  font-size: 1.1rem
  background-color: #fff
  border-bottom: 1px solid #ddd
  word-break: break-word

.content-grid
  display: flex
  flex: 1
  overflow: hidden

.sidebar
  display: flex
  flex-direction: column
  flex: 0 0 280px
  max-width: 300px
  padding: 0.5rem
  box-sizing: border-box

.info-card
  display: flex
  flex-direction: column
  gap: 0.4rem
  padding: 0.5rem
  word-break: break-word
  background-color: #fff
  border-radius: 4px
  margin-bottom: 0.5rem

.menu
  flex: 1
  display: flex
  flex-direction: column
  background-color: #fff
  border-radius: 4px

.menu-scroll
  flex: 1
  overflow-y: auto
  padding: 0.5rem

.menu-footer
  display: flex
  align-items: flex-end
  padding: 0.5rem

.btn-close-call
  color: $negative
  border: 2px solid $negative
  background-color: #fff
  &:hover
    background-color: $negative !important
    color: #fff
.main-content
  flex: 1
  display: flex
  flex-direction: column
  padding: 0.5rem
  overflow: hidden

.table-container
  flex: 1
  overflow-x: auto
  overflow-y: auto
  background-color: #fff
  border-radius: 4px
  padding: 0.5rem

@media (max-width: 1366px)
  .content-grid
    display: grid
    grid-template-columns: 1fr
    grid-auto-rows: auto
    gap: 0.5rem

  .sidebar
    display: contents

  .info-card
    order: 1
    margin-bottom: 0

  .main-content
    order: 2
    padding: 0.5rem
    min-height: 400px

  .menu
    order: 3

</style>
